import { type DriverBehaviorThresholds } from 'types/customer.types';

export const DEFAULT_DRIVER_BEHAVIOR_THRESHOLDS: DriverBehaviorThresholds = {
  lowThreshold: 5,
  highThreshold: 15,
};
